export const VAT_RATE_0 = 4;
export const VAT_RATE_ZW = 5;
export const VAT_RATE_NP = 6;
export const VAT_RATE_OO = 7;
export const CALCULATE_SOURCE_NET = 'net';
export const CALCULATE_SOURCE_GROSS = 'gross';
